const budgetLang = {
  en: {
    budget: "Budget",
  },
  es: {
    budget: "Presupuesto",
  },
};
export default budgetLang;
